import React from 'react';
import "./AuthMenu.scss"
import LogoCatbears from '../../components/LogoCatbears/LogoCatbears';

const AuthMenu = ({children}) => {
	return(
		<>
      <div className={"Onboarding-content Onboarding-container-no-footer login-page-container hideScrollbar"}>
          <LogoCatbears
            isCentered
            isTapToLandingPage
            isFixed={false}
          />
          {children}
        <div className='Room'></div>
      </div>
		</>
	)
}

export default AuthMenu;